export default {
  profile: {
    title: "Profile",
    subtitle: "Personal data, portfolio, and professional information.",
    downloadPdf: "Download PDF",
    downloadPdfGenerating: "Preparing PDF…",
    downloadPdfError: "Could not download profile PDF",
    tabs: {
      personal: "My details",
      creativeSelfDefinition: "Self-definition",
      education: "Education",
      languages: "Languages",
      work: "Work",
      portfolio: "Portfolio",
      accounts: "Accounts",
      memberships: "Unions",
    },
    avatar: {
      title: "Avatar",
      imageLabel: "Image",
      alt: "Avatar",
    },
    general: {
      title: "General",
      lastName: "Last name",
      firstName: "First name",
      middleName: "Middle name",
      middlePlaceholder: "Your middle name",
      birthDate: "Date of birth",
      phone: "Phone",
      email: "E-mail",
      gender: "Gender",
      male: "Male",
      female: "Female",
      about: "About",
    },
    password: {
      sectionTitle: "Password change",
      sectionLead: "Account security",
      change: "Change password",
      current: "Current password",
      new: "New password",
      repeat: "Repeat password",
      resetHint: "Enter your current password and a new one (at least 8 characters).",
      changeSubmit: "Save new password",
      changeSubmitting: "Saving…",
      changeSuccess: "Your password was updated",
      changeEmpty: "Fill in all fields",
      changeMustDifferFromCurrent: "The new password must be different from your current password",
      changeMismatch: "New password and confirmation do not match",
      changeTooShort: "New password must be at least 8 characters",
      changeFail: "Could not change password",
    },
    creativeSelfDefinition: {
      introTitle: "Creative self-definition",
      introLead:
        "Choose the direction, sub-branch, and role that best describe your creative practice.",
      directionLabel: "Industry direction",
      subDirectionLabel: "Sub-branch",
      catalogRoleLabel: "Role",
      catalogRoleHint:
        "Start with the list so your profile can be matched with relevant recommendations, events, and services.",
      editSuggestedRole: "Edit your wording",
      customToggle: "I can't find my role",
      customRoleTitle: "Suggest your role",
      customRoleLabel: "Role name",
      proposedDescriptionLabel: "Role description (optional)",
      proposedDescriptionPlaceholder:
        "Briefly describe what you do in this role — moderators will see this when reviewing your suggestion.",
      proposedDescriptionHint: "At most {{max}} characters.",
      customPlaceholder: "e.g. documentary podcast author",
      customHint:
        "If the list does not include the right role, enter your wording. We will save it to your profile and send it to moderators for review.",
      customCancel: "Cancel",
      customSaveSubmit: "Save and send for review",
      customSaving: "Saving and sending…",
      blockDescription: "Role description",
      blockRecommendations: "What may be useful on the platform",
      blockWhoFits: "Who it may suit",
      noCopyFallback: "There is no extended text for this wording yet.",
      roleValidation: "Choose a role from the list or suggest your own wording.",
      suggestionSent: "The role was saved to your profile and sent to moderators for review.",
      suggestionError: "Could not send the role for review",
      customNeedSub: "Choose a sub-branch first so we know where this new role belongs.",
      customRoleDuplicateCatalog:
        "This role name is already in the list for the selected sub-branch. Pick it from the list — you do not need to submit a suggestion.",
      catalogNeedExplicitSub:
        "This catalog role is linked to several sub-branches — choose a sub-branch before saving.",
      loadError: "Could not load self-definition data",
      saveError: "Could not save self-definition",
      formActionsAria: "Discard edits or save self-definition",
    },
    loadError: "Could not load profile",
    saveError: "Could not save",
    uploadError: "Could not upload file",
    saving: "Saving…",
    emailReadOnlyHint: "Contact support to change your e-mail",
    confirmDelete: {
      title: "Delete this entry?",
      message: "This cannot be undone. The entry will be permanently removed.",
      confirm: "Delete",
    },
    achievementType: {
      1: "Diploma",
      2: "Certificate",
      3: "Letter of thanks",
      4: "Patent",
      5: "Award",
      6: "Medal",
      7: "Competition",
      8: "Other",
    },
    tabsData: {
      loadFailed: "Failed to load data",
      saveFailed: "Failed to save",
      deleteFailed: "Failed to delete",
      edit: "Edit",
      delete: "Delete",
      cancel: "Cancel",
      pick: "Select…",
      optional: "None",
      now: "present",
      level: "Education level",
      institution: "Educational institution",
      speciality: "Speciality",
      institutionFromList: "Pick an institution from the suggestions",
      specialityFromList: "Pick a speciality from the suggestions",
      startYear: "Start year",
      endYear: "End year",
      currentStudy: "Currently studying",
      addEducation: "Add education",
      editEducation: "Edit education",
      company: "Company / organization",
      position: "Position",
      yearsExperience: "Years of experience",
      yearsShort: "{{n}} years",
      industry: "Industry",
      specialization: "Specialization",
      addWork: "Add work experience",
      editWork: "Edit work experience",
      achievementName: "Title",
      achievementType: "Type",
      customType: "Describe the type",
      url: "Link",
      eventDate: "Date",
      image: "Attachment",
      uploadFile: "Upload file",
      attachmentMaxSizeWarning: "Maximum file size is 10 MB.",
      attachmentFileTooLarge: "This file is larger than 10 MB. Please choose a smaller file.",
      attachmentDropZoneTitle: "Click to choose a file",
      attachmentDropZoneSubtitle:
        "Accepted: PDF; JPEG, PNG, and JFIF images; MP4, MOV, AVI, MKV, and WebM video; MP3, WAV, OGG, FLAC, AAC, M4A, M4B, M4P, and M4V audio.",
      attachmentUploading: "Uploading…",
      attachmentReplace: "Replace file",
      attachmentClear: "Remove file",
      addPortfolio: "Add achievement",
      editPortfolio: "Edit achievement",
      addAccount: "Add account",
      editAccount: "Edit link",
      language: "Language",
      languageLevel: "Proficiency",
      addLanguage: "Add language",
      editLanguage: "Edit language",
      languagePickBoth: "Select both language and proficiency level",
      languageUnknown: "Language",
      levelUnknown: "Level",
    },
    save: "Save changes",
    saved: "Saved",
    personalFormActionsAria: "Discard edits or save personal details",
    addEducation: "Add education",
    addLanguage: "Add language",
    addWork: "Add job",
    addPortfolio: "Add achievement",
    addAccount: "Add account",
    memberships: {
      tabTitle: "Unions",
      tabSubtitle: "Add unions, associations, and communities you belong to.",
      add: "Add union",
      addFirst: "Add your first union",
      emptyTitle: "No unions yet",
      emptyLead: "Add a union, association, or community — it will appear in your profile.",
      statusApproved: "Request approved",
      statusPending: "Awaiting approval",
      statusNotConfirmed: "Not confirmed",
      statusRejected: "Rejected",
      statusWithdrawn: "Withdrawn",
      rejectionReasonLabel: "Rejection reason",
      approvedBy: "Approved by: {{name}}",
      approvedOn: "{{date}}",
      requiresApproval: "Review required",
      autoAccept: "Join immediately",
      loadError: "Failed to load unions",
      createdToastApproved: "Union added",
      createdToastPending: "Request sent and awaiting approval",
      updatedToast: "Union updated",
      deleteTitle: "Remove union?",
      deleteMessage: "\u00ab{{path}}\u00bb will be removed from your profile. This cannot be undone.",
      deleteError: "Failed to remove the union",
      resetApprovalNotice:
        "This union requires review. After saving, the request will return to awaiting approval.",
      wizard: {
        title: "Add union",
        editTitle: "Edit union",
        back: "Back",
        next: "Next",
        finish: "Finish",
        step1: "Union type",
        step2: "Industry",
        step3: "Choose union",
        step4: "Confirmation",
        searchUnionLabel: "Find a union",
        searchUnionPlaceholder: "Enter a union or branch name…",
        searchNoResults: "No results",
        searchTreeLoading: "Looking for matching options…",
        pickKind: "Select a union type",
        pickIndustry: "Select an industry",
        pickInTree: "Choose the right union or branch",
        stopHere: "Choose this union",
        stopHereHint: "Your request will be submitted for the selected union.",
        selectedNode: "You selected",
        confirmTitle: "Review your choices",
        confirmKind: "Union type",
        confirmGroup: "Union",
        loadError: "Failed to load data for this step",
        createError: "Failed to submit the request",
        updateError: "Failed to update the union",
        emptyIndustries: "No unions are available for this type yet",
        membershipNotAllowed:
          "You cannot join this union directly. Choose another branch.",
        stopHereDisabledHint:
          "You cannot request to join this union directly. Choose a branch below.",
      },
    },
    linked: "Connected",
    notLinked: "Not connected",
    since: "since {{year}}",
    portal: {
      pageTitle: "Account",
      pageSubtitle: "Russian State Library portal: services and participant profile.",
      sidebarAria: "User profile",
      navAria: "Account sections",
      overviewNav: "Overview",
      backToSite: "Back to website",
      logout: "Sign out",
      welcome: "Hello, {{name}}!",
      welcomeHint:
        "Manage your profile, connect accounts, and access library events and services.",
      completionLabel: "Completed: {{percent}}%",
      fillProfile: "Complete profile",
      profileComplete: "Your profile is complete",
      completionProgressAria: "Profile completion",
      servicesTitle: "Portal services",
      services: {
        events: {
          title: "Events",
          desc: "Program, registration, and materials.",
        },
        projects: {
          title: "Projects",
          desc: "Initiatives, collaborations, and portfolios.",
        },
        deposit: {
          title: "Deposit",
          desc: "Submit works and deposit support.",
        },
        admin: {
          title: "Administration",
          desc: "Roles and users — shown only when your account has the required permissions.",
        },
      },
      anketaTitle: "Participant profile",
      anketaHint:
        "Tell us about yourself: it helps us match you with events and projects.",
      completionMissingTitle: "What to complete next",
      completionMissingGoAria: "Go to complete: {{label}}",
      languageSwitch: {
        title: "Interface language",
        groupAria: "Choose interface language",
        ruShort: "Russian",
        enShort: "English",
        ruAria: "Switch interface to Russian",
        enAria: "Switch interface to English",
      },
    },
  },
}
